/** Lab Events column — CM / TM / DM only (not SM / Master / Member). */
export function canShowMemberEvents(role: string | null | undefined): boolean {
  return (
    role === 'company-master' ||
    role === 'triple-master' ||
    role === 'double-master'
  )
}
